import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';

import apiGuest from '../../api/Guest';

import LinkLang from '../../components/Wraps/LinkLang';

import { spanish } from '../../config/config';

const Guest = () => {
  const [content, setContent] = useState(null);
  const fboReferido = useSelector((globalState) => globalState.referralInfo);
  const quote = useSelector((globalState) => globalState.cartInfo);
  let url = 'https://www.foreverliving.com.mx/s/MEX';
  url = fboReferido.referralId
    ? (url += `/${fboReferido.referralId}/${quote.IdCarrito}`)
    : (url += `/0/${quote.IdCarrito}`);
  useEffect(async () => {
    setContent(await apiGuest.getContent());
  }, []);
  return (
    <div className={styles.container}>
      <Helmet title="Forever Living" />
      <div className={styles.content}>
        <div className={styles.links}>
          <LinkLang className="btn btn-yellow" to="/checkout/address">
            {spanish ? content?.ContinueSpanish : content?.ContinueEnglish}
          </LinkLang>
        </div>
        <span>Ó</span>
        <div className={styles.join}>
          <a
            href={url}
            className="btn btn-white"
            target="_blank"
            rel="noreferrer"
          >
            {spanish
              ? 'Registrate y obtén un 5% de descuento'
              : 'Register and Get 5% discount'}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Guest;
